var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from "react";
import { StyledTab } from "./styled";
export var Tab = function (_a) {
    var index = _a.index, onChange = _a.onChange, rest = __rest(_a, ["index", "onChange"]);
    var onClick = useCallback(function () { return onChange && onChange(index || 0); }, [index, onChange]);
    return (React.createElement(StyledTab, __assign({ justifyContent: "center", alignItems: "center", flex: { grow: 1, shrink: 1 }, basis: "100%", onClick: rest.disabled ? undefined : onClick }, rest), rest.label));
};
